import React from "react";
import { TiAttachmentOutline } from "react-icons/ti";

const buttonTypes = {
  default:
    "rounded-lg px-3 py-[3px] bg-buttonBg text-base relative flex items-center text-white font-semibold hover:bg-buttonBgHover transition-colors",
  addNew:
    "gradient-bg bg-buttonBg rounded-lg py-[3px] px-3 max-w-[220px] font-medium mr-2 text-Poppins relative flex items-center text-white font-semibold hover:bg-buttonBgHover transition-colors",
  cancel:
    "border-[#4a7aae] border rounded-lg px-3 py-[2px] text-base text-[#4a7aae] flex items-center font-semibold hover:bg-gray-100 transition-colors",
  file: "bg-buttonBg rounded-lg pl-4 pe-2 py-[2px] text-base relative flex items-center text-white font-semibold hover:bg-buttonBgHover transition-colors",
  success:
    "rounded-lg px-3 py-[3px] bg-green-600 text-base relative flex items-center text-white font-semibold hover:bg-green-700 transition-colors",
  error:
    "rounded-lg px-3 py-[3px] bg-red-600 text-base relative flex items-center text-white font-semibold hover:bg-red-700 transition-colors",
};

const allowedExtensions = [
  "pdf",
  "png",
  "jpg",
  "jpeg",
  "gif",
  "svg",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "txt",
  "ppt",
  "pptx",
];

const statusIcons = {
  success: (
    <svg
      className="w-4 h-4 ml-1"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 13l4 4L19 7"
      />
    </svg>
  ),
  error: (
    <svg
      className="w-4 h-4 ml-1"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  ),
};

const CustomButton = ({
  label,
  buttonType = "default",
  disable = false,
  status, // 'success', 'error', or undefined
  isLoading = false,
  className = "",
  ...props
}) => {
  const getButtonClass = () => {
    if (status === "success") return buttonTypes.success;
    if (status === "error") return buttonTypes.error;
    if (disable)
      return `${
        buttonTypes[buttonType] || buttonTypes.default
      } cursor-not-allowed bg-gray-400`;
    return buttonTypes[buttonType] || buttonTypes.default;
  };

  return (
    <div className="flex flex-col items-start">
      <button
        className={`pc-button pc-button--${status || buttonType} ${getButtonClass()} ${className} transition-all ease-in-out flex flex-row text-sm items-center justify-center`}
        {...props}
        title={
          buttonType === "file"
            ? `Max File Size: 50MB`
            : null
        }
        disabled={disable || isLoading}
        type="button"
      >
        {isLoading ? (
          <div className="flex items-center">
            <svg
              className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            Processing...
          </div>
        ) : (
          <>
            {label}
            {buttonType === "file" && (
              <TiAttachmentOutline className="text-xl ml-1" />
            )}
            {status && statusIcons[status]}
          </>
        )}
      </button>

      {buttonType === "file" && (
        <span className="text-xs text-gray-400 mt-1">
          Upload files (Max 50MB)
        </span>
      )}
    </div>
  );
};

export default CustomButton;
